import React from 'react';
import { BookOpenIcon, FileTextIcon, Gamepad2Icon, MessageCircleIcon } from 'lucide-react';
import { problems } from '../data/landing';
import { SectionHeading } from './SectionHeading';
const icons = {
  file: FileTextIcon,
  game: Gamepad2Icon,
  book: BookOpenIcon,
  chat: MessageCircleIcon
};
export function ProblemsSection() {
  return <section className="bg-white py-12 md:py-24" data-id="element-149" data-mp="36mujvx55bblv">
      <div className="mx-auto max-w-[1180px] px-5 md:px-8" data-id="element-150" data-mp="2somucaafvckq">
        <SectionHeading eyebrow="Sound familiar?" title="You said yes to leading." highlight="Then came the planning." data-id="element-151" data-mp="2sr91w9xbxs2y" />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-152" data-mp="2iqynwn3h0gmq">
          {problems.map(problem => {
          const Icon = icons[problem.icon];
          return <article key={problem.title} className="flex flex-col rounded-2xl border border-navy/[0.08] bg-ivory p-6 md:p-7" data-id="element-153" data-mp="gzc1yzyfrbx4">
                <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-teal/10 text-teal" data-id="element-154" data-mp="lyoqrq8vat2c">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-155" data-mp="1i5er5m7wsr0y" />
                </div>
                <h3 className="mt-5 font-display text-[26px] font-bold uppercase leading-none text-navy" data-id="element-156" data-mp="1d85247ofmhdn">{problem.title}</h3>
                <p className="mt-3 text-[15px] text-muted" data-id="element-157" data-mp="1rvq5m2p7yim3">{problem.body}</p>
              </article>;
        })}
        </div>
        <p className="mx-auto mt-12 max-w-[720px] text-center font-display text-[28px] font-bold uppercase leading-tight text-navy md:text-[34px]" data-id="element-158" data-mp="1mzj02b0qj94o">
          It’s not a lack of commitment. <span className="text-teal" data-id="element-159" data-mp="ualrizmbsqp4">It’s a lack of time.</span>
        </p>
      </div>
    </section>;
}